import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import db from "./Firebase";

function Contactus() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: ""
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { name, email, message } = formData;
        if (!name || !email || !message) {
            Swal.fire("Error", "Please fill in all fields.", "error");
            return;
        }

        try {
            await db.collection("website_contactus").add({
                name,
                email,
                message,
                timestamp: new Date()
            });
            Swal.fire("Success", "Your message has been sent!", "success");
            setFormData({ name: "", email: "", message: "" });
        } catch (error) {
            console.error("Error sending message:", error);
            Swal.fire("Error", "Failed to send message. Try again later.", "error");
        }
    };

    useEffect(() => {
        // ----- MENU TOGGLE -----
        const menuToggle = document.getElementById("menuToggle");
        const navLinks = document.getElementById("navLinks");

        if (menuToggle && navLinks) {
            const handleMenuClick = () => {
                menuToggle.classList.toggle("active");
                navLinks.classList.toggle("show");
            };

            menuToggle.addEventListener("click", handleMenuClick);

            // cleanup
            return () => {
                menuToggle.removeEventListener("click", handleMenuClick);
            };
        }
    }, []);

    useEffect(() => {
        // ----- TEAM SLIDER -----
        const slider = document.querySelector(".team-slider");
        const track = document.querySelector(".team-track");
        const nextBtn = document.querySelector(".team-arrow.next");
        const prevBtn = document.querySelector(".team-arrow.prev");
        const cards = Array.from(document.querySelectorAll(".team-card"));

        if (!slider || !track || !nextBtn || !prevBtn || !cards.length) return;

        let scrollX = 0;

        const cardStep = () => {
            if (!cards.length) return 0;
            const style = getComputedStyle(track);
            const gap = parseFloat(style.columnGap || style.gap || 0);
            return cards[0].offsetWidth + gap;
        };

        const maxScroll = () =>
            Math.max(0, track.scrollWidth - slider.clientWidth - 1);

        const moveSlider = (delta) => {
            scrollX = Math.min(Math.max(0, scrollX + delta), maxScroll());
            track.style.transform = `translateX(-${scrollX}px)`;
            prevBtn.classList.toggle("is-disabled", scrollX <= 0);
            nextBtn.classList.toggle("is-disabled", scrollX >= maxScroll());
        };

        const scrollNext = () => moveSlider(cardStep());
        const scrollPrev = () => moveSlider(-cardStep());
        const handleResize = () => moveSlider(0);

        nextBtn.addEventListener("click", scrollNext);
        prevBtn.addEventListener("click", scrollPrev);
        window.addEventListener("resize", handleResize);

        // initialize position
        moveSlider(0);

        // cleanup on unmount
        return () => {
            nextBtn.removeEventListener("click", scrollNext);
            prevBtn.removeEventListener("click", scrollPrev);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>
            <header class="top-4 z-40 " style={{ marginTop: "10px" }}>
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div
                        class="bg-white/90 backdrop-blur ring-1 ring-black/5 rounded-[20px] md:rounded-[28px] px-3 sm:px-4 md:px-6">

                        <div class="flex items-center justify-between h-12">
                            <a href="#" class="flex items-center gap-2">
                                <img src="assets/youvati_logo.png" alt="Youvati" class="w-auto" style={{ height: "2rem" }} />
                            </a>


                            <nav class="hidden md:flex items-center  text-sm" style={{ gap: "2.2rem", fontWeight: "600" }}>
                                <Link to="/" class="hover:text-[#7872F8] ">Home</Link>
                                {/* <Link to="" class="hover:text-[#7872F8]">Partner with us</Link> */}
                                <Link to="/aboutus" class="hover:text-[#7872F8]">About us</Link>
                                <Link to="/contactus" class="text-[#7872F8]  px-2 py-0.5 rounded-lg bg-[#F0EFFE]">Contact us</Link>
                            </nav>


                            <a href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN"
                                target="_blank">
                                <div class="hidden md:flex items-center gap-2 rounded-xl border px-2.5 py-0.5 shadow-sm">
                                    <span class="font-bold text-sm">Download App</span>
                                    <img src="assets/arrow.png" alt="qr" class="h-6 w-6" />
                                </div>
                            </a>


                            <button id="menuBtn"
                                class="md:hidden inline-flex items-center justify-center rounded-xl border px-2 py-1"
                                aria-controls="mobileMenu" aria-expanded="false" aria-label="Open Menu">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-5 h-5">
                                    <path fill-rule="evenodd"
                                        d="M3.75 5.25a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>


                        <div id="mobileMenu" class="md:hidden hidden border-t border-black/5 pt-3 pb-3">
                            <nav class="flex flex-col gap-3 text-sm" style={{ fontWeight: "600" }}>
                                <a class="text-[#7872F8] px-2 py-1 rounded-lg bg-[#F0EFFE] w-max" href="#home">Home</a>
                                <a class="hover:text-[#7872F8]" href="#partners">Partner with us</a>
                                <a class="hover:text-[#7872F8]" href="#about">About us</a>
                                <a class="hover:text-[#7872F8]" href="#contact">Contact us</a>
                                <a class="inline-flex items-center gap-2 rounded-xl border px-3 py-2 w-max"
                                    href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN">
                                    <span class="font-bold">Download App</span>
                                    <img src="assets/arrow.png" class="h-6 w-6" />
                                </a>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>

            <section className="contact-section">
                <div className="contact-card">
                    <div className="contact-info">
                        <h1 className="contact-title">Get In <span className="highlight">Touch</span></h1>
                        <p className="contact-description">
                            We're here to help! Whether you have questions, feedback, or need support, our team is ready to assist you.
                        </p>

                        <div className="contact-item">
                            <span>Email:</span>
                            <a href="mailto:youvati@example.com">info@youvati.com</a>
                        </div>
                        <div className="contact-item">
                            <span>Phone:</span>
                            <a href="tel:+911122112233">+91 7065038327</a>
                        </div>
                        <div className="contact-item">
                            <span>Address:</span>
                            <p>Branch, 371, Ground Floor, 35, Khasra No. 369,370, 382, 100 Feet Rd, near Union Bank, Ghitorni, New Delhi, Delhi 110030</p>
                        </div>
                    </div>

                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="name">Your Name</label>
                                <input type="text" id="name" value={formData.name} onChange={handleChange} placeholder="Your name" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input type="email" id="email" value={formData.email} onChange={handleChange} placeholder="Your email address" />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea id="message" value={formData.message} onChange={handleChange} placeholder="Write something..."></textarea>
                        </div>

                        <button type="submit" className="submit-button">
                            <span>Send Message</span>
                            <div className="icon-wrapper">
                                <img src="assets/arrow2.png" className="h-7 w-7" alt="arrow" />
                            </div>
                        </button>
                    </form>
                </div>
            </section>


            <section id="download" class="py-12 md:py-16 lg:py-14">
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="rounded-[24px] md:rounded-[32px] bg-[#3F3B88] text-white overflow-hidden">

                        <div
                            class="flex flex-col p-6 md:p-10 lg:p-0 lg:grid lg:grid-cols-[minmax(220px,360px),1fr,180px] lg:items-center lg:gap-6">


                            <div class="order-3 lg:order-1 w-full lg:w-auto flex lg:justify-start mt-6 lg:mt-0"
                                style={{ marginLeft: "-3rem", marginBottom: "-3rem" }}>
                                <img src="assets/handmockup.png" alt="Youvati app preview"
                                    class="w-auto max-h-64 md:max-h-72 lg:max-h-80 object-contain pt-4" />
                            </div>


                            <div class="order-1 lg:order-2 w-full space-y-3 md:space-y-4 text-left lg:px-8">
                                <h3 class="text-2xl md:text-3xl font-syne leading-tight">
                                    To Achieve Your Goals, There’s Only One Thing You Need.
                                </h3>
                                <p class="text-lg md:text-xl font-syne">
                                    Download <span class="text-[#BFC3FF]">Youvati</span>
                                </p>
                                <p class="text-white/80 max-w-md">
                                    Scan the QR code to download the app on your phone
                                </p>
                            </div>


                            <div
                                class="order-2 lg:order-3 flex flex-row lg:flex-col items-center justify-start lg:justify-center gap-4 mt-4 lg:mt-0 pr-0 lg:pr-10">


                                <div class="h-20 w-20 md:h-24 md:w-24 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('assets/y_icon.png')", backgroundRepeat: "no-repeat", backgroundPosition: "center", position: "relative", backgroundSize: "cover", height: "10rem" }}></div>


                                <div class=" h-20 w-20 md:h-24 md:w-24 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('assets/qrcode.png')", backgroundRepeat: "no-repeat", backgroundPosition: "center", position: "relative", backgroundSize: "cover", height: "10rem" }}></div>


                            </div>

                        </div>
                    </div>
                </div>
            </section>


            <Footer />


            <style>{`
        :root {
            --color-primary: #938EFA;
            --color-primary-dark: #6c64f8;
            --color-bg: #F6F5FA;
            --color-white: #fff;
            --color-dark-bg: #3b338f;
            --text-dark: #111;
            --text-gray: #555;
        }

        body {
            font-family: 'Montserrat', sans-serif;
            margin: 0;
            padding: 0;
            background-color: var(--color-bg);
            color: var(--text-dark);
        }

        /* ---------------- CONTACT SECTION ---------------- */
        .contact-section {
            max-width: 1200px;
            margin: 0 auto;
            padding: 80px 24px;
        }

        .contact-card {
            background: var(--color-white);
            border-radius: 32px;
            padding: 56px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 80px;
            box-shadow: 0 8px 40px rgba(0, 0, 0, 0.04);
        }

        .contact-info {
            flex: 1;
        }

        .contact-title {
            font-family: 'Syne', sans-serif;
            font-weight: 700;
            font-size: 44px;
            margin: 0 0 16px;
        }

        .contact-title .highlight {
            color: var(--color-primary);
        }

        .contact-description {
            font-size: 17px;
            color: var(--text-gray);
            margin-bottom: 32px;
            max-width: 400px;
        }

        .contact-item {
            margin-bottom: 20px;
        }

        .contact-item span {
            display: block;
            color: var(--text-gray);
            font-weight: 500;
            margin-bottom: 6px;
        }

        .contact-item a,
        .contact-item p {
            color: var(--text-dark);
            font-weight: 600;
            font-size: 18px;
            text-decoration: none;
        }

        /* -------- FORM -------- */
        .contact-form {
            flex: 1.2;
            display: flex;
            flex-direction: column;
            gap: 24px;
        }

        .form-row {
            display: flex;
            gap: 24px;
        }

        .form-group {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        label {
            font-weight: 600;
        }

        input,
        textarea {
            background: #f1efff;
            border: none;
            border-radius: 12px;
            padding: 14px 16px;
            font-size: 16px;
            font-family: 'Montserrat', sans-serif;
            resize: none;
            color: var(--text-dark);
        }

        input::placeholder,
        textarea::placeholder {
            color: #aaa;
        }

        textarea {
            height: 160px;
        }

        .submit-button {
            background: var(--color-primary);
            color: var(--color-white);
            border: none;
            border-radius: 28px;
            padding: 12px 20px;
            font-size: 17px;
            font-weight: 500;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            transition: 0.3s;
        }

        .submit-button:hover {
            background: var(--color-primary-dark);
        }

        .submit-button .icon-wrapper {
            background: var(--color-white);
            border-radius: 50%;
            width: 34px;
            height: 34px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .submit-button img {
            width: 22px;
            height: 22px;
        }

        /* ---------------- DOWNLOAD SECTION ---------------- */
        .download-section {
            padding: 80px 24px;
        }

        .download-container {
            background: var(--color-primary-dark);
            border-radius: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 48px 64px;
            gap: 60px;
            flex-wrap: wrap;
            color: var(--color-white);
        }

        .download-left {
            display: flex;
            align-items: center;
            gap: 40px;
            flex: 1;
            min-width: 320px;
        }

        .download-left img {
            width: 180px;
            height: auto;
            border-radius: 24px;
        }

        .download-text h2 {
            font-family: 'Syne', sans-serif;
            font-size: 28px;
            font-weight: 700;
            margin: 0 0 16px;
            line-height: 1.3;
        }

        .download-text p {
            margin: 0;
            font-size: 17px;
            color: #ddd;
        }

        .download-qr {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
        }

        .qr-icon {
            background: var(--color-primary);
            width: 90px;
            height: 90px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .qr-icon img {
            width: 42px;
        }

        .qr-code {
            background: var(--color-white);
            border-radius: 10px;
            padding: 8px;
        }

        .qr-code img {
            width: 80px;
            height: 80px;
        }

        /* ---------------- RESPONSIVE ---------------- */
        /* ---------------- RESPONSIVE ---------------- */
        @media (max-width: 1024px) {
            .contact-card {
                flex-direction: column;
                gap: 48px;
                padding: 40px 32px;
            }

            .contact-title {
                font-size: 36px;
            }

            .form-row {
                flex-direction: column;
                gap: 20px;
            }

            /* ✅ make all form fields full width on mobile/tablet */
            .form-group {
                width: 100%;
            }

            .contact-form {
                width: 100%;
            }

            input,
            textarea {
                width: 100%;
                box-sizing: border-box;
            }

            .download-container {
                flex-direction: column;
                text-align: center;
                padding: 48px 32px;
            }

            .download-left {
                flex-direction: column;
                align-items: center;
                gap: 24px;
            }
        }

        @media (max-width: 600px) {
            .contact-section {
                padding: 60px 16px;
            }

            .contact-card {
                padding: 32px 20px;
            }

            input,
            textarea {
                font-size: 15px;
            }

            .submit-button {
                font-size: 15px;
            }

            /* ✅ Ensure submit button spans full width on small phones */
            .submit-button {
                width: 100%;
                justify-content: center;
                gap: 8px;
            }

            .download-left img {
                width: 140px;
            }

            .download-text h2 {
                font-size: 22px;
            }

            .qr-icon {
                width: 70px;
                height: 70px;
            }

            .qr-code img {
                width: 70px;
                height: 70px;
            }
        }


        `}</style>
        </>
    );
}

export default Contactus;






// import React, { useEffect, useState } from "react";
// import Footer from "./Footer";
// import { useNavigate, Link, useParams } from 'react-router-dom';


// import Swal from 'sweetalert2'
// import { useNavigate, Link, useParams } from 'react-router-dom';
// import db from "./Firebase";
// import { storage } from './Firebase';
// import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// import Moment from 'moment';
// import { extendMoment } from 'moment-range';



// // import "./portfolio.css";

// function Contactus() {

//     useEffect(() => {
//         // ----- MENU TOGGLE -----
//         const menuToggle = document.getElementById("menuToggle");
//         const navLinks = document.getElementById("navLinks");

//         if (menuToggle && navLinks) {
//             const handleMenuClick = () => {
//                 menuToggle.classList.toggle("active");
//                 navLinks.classList.toggle("show");
//             };

//             menuToggle.addEventListener("click", handleMenuClick);

//             // cleanup
//             return () => {
//                 menuToggle.removeEventListener("click", handleMenuClick);
//             };
//         }
//     }, []);

//     useEffect(() => {
//         // ----- TEAM SLIDER -----
//         const slider = document.querySelector(".team-slider");
//         const track = document.querySelector(".team-track");
//         const nextBtn = document.querySelector(".team-arrow.next");
//         const prevBtn = document.querySelector(".team-arrow.prev");
//         const cards = Array.from(document.querySelectorAll(".team-card"));

//         if (!slider || !track || !nextBtn || !prevBtn || !cards.length) return;

//         let scrollX = 0;

//         const cardStep = () => {
//             if (!cards.length) return 0;
//             const style = getComputedStyle(track);
//             const gap = parseFloat(style.columnGap || style.gap || 0);
//             return cards[0].offsetWidth + gap;
//         };

//         const maxScroll = () =>
//             Math.max(0, track.scrollWidth - slider.clientWidth - 1);

//         const moveSlider = (delta) => {
//             scrollX = Math.min(Math.max(0, scrollX + delta), maxScroll());
//             track.style.transform = `translateX(-${scrollX}px)`;
//             prevBtn.classList.toggle("is-disabled", scrollX <= 0);
//             nextBtn.classList.toggle("is-disabled", scrollX >= maxScroll());
//         };

//         const scrollNext = () => moveSlider(cardStep());
//         const scrollPrev = () => moveSlider(-cardStep());
//         const handleResize = () => moveSlider(0);

//         nextBtn.addEventListener("click", scrollNext);
//         prevBtn.addEventListener("click", scrollPrev);
//         window.addEventListener("resize", handleResize);

//         // initialize position
//         moveSlider(0);

//         // cleanup on unmount
//         return () => {
//             nextBtn.removeEventListener("click", scrollNext);
//             prevBtn.removeEventListener("click", scrollPrev);
//             window.removeEventListener("resize", handleResize);
//         };
//     }, []);

//     return (
//         <>


//             <header class="top-4 z-40 " style={{ marginTop: "10px" }}>
//                 <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <div
//                         class="bg-white/90 backdrop-blur ring-1 ring-black/5 rounded-[20px] md:rounded-[28px] px-3 sm:px-4 md:px-6">

//                         <div class="flex items-center justify-between h-12">
//                             <a href="#" class="flex items-center gap-2">
//                                 <img src="assets/youvati_logo.png" alt="Youvati" class="w-auto" style={{ height: "2rem" }} />
//                             </a>


//                             <nav class="hidden md:flex items-center  text-sm" style={{ gap: "2.2rem", fontWeight: "600" }}>
//                                 <Link to="/" class="hover:text-[#7872F8] ">Home</Link>
//                                 {/* <Link to="" class="hover:text-[#7872F8]">Partner with us</Link> */}
//                                 <Link to="/aboutus" class="hover:text-[#7872F8]">About us</Link>
//                                 <Link to="/contactus" class="text-[#7872F8]  px-2 py-0.5 rounded-lg bg-[#F0EFFE]">Contact us</Link>
//                             </nav>


//                             <a href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN"
//                                 target="_blank">
//                                 <div class="hidden md:flex items-center gap-2 rounded-xl border px-2.5 py-0.5 shadow-sm">
//                                     <span class="font-bold text-sm">Download App</span>
//                                     <img src="assets/arrow.png" alt="qr" class="h-6 w-6" />
//                                 </div>
//                             </a>


//                             <button id="menuBtn"
//                                 class="md:hidden inline-flex items-center justify-center rounded-xl border px-2 py-1"
//                                 aria-controls="mobileMenu" aria-expanded="false" aria-label="Open Menu">
//                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
//                                     class="w-5 h-5">
//                                     <path fill-rule="evenodd"
//                                         d="M3.75 5.25a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z"
//                                         clip-rule="evenodd" />
//                                 </svg>
//                             </button>
//                         </div>


//                         <div id="mobileMenu" class="md:hidden hidden border-t border-black/5 pt-3 pb-3">
//                             <nav class="flex flex-col gap-3 text-sm" style={{ fontWeight: "600" }}>
//                                 <a class="text-[#7872F8] px-2 py-1 rounded-lg bg-[#F0EFFE] w-max" href="#home">Home</a>
//                                 <a class="hover:text-[#7872F8]" href="#partners">Partner with us</a>
//                                 <a class="hover:text-[#7872F8]" href="#about">About us</a>
//                                 <a class="hover:text-[#7872F8]" href="#contact">Contact us</a>
//                                 <a class="inline-flex items-center gap-2 rounded-xl border px-3 py-2 w-max"
//                                     href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN">
//                                     <span class="font-bold">Download App</span>
//                                     <img src="assets/arrow.png" class="h-6 w-6" />
//                                 </a>
//                             </nav>
//                         </div>
//                     </div>
//                 </div>
//             </header>


//             <section class="contact-section">
//                 <div class="contact-card">
//                     <div class="contact-info">
//                         <h1 class="contact-title">Get In <span class="highlight">Touch</span></h1>
//                         <p class="contact-description">
//                             We're here to help! Whether you have questions, feedback, or need support, our team is ready to
//                             assist you.
//                         </p>

//                         <div class="contact-item">
//                             <span>Email:</span>
//                             <a href="mailto:youvati@example.com">info@youvati.com</a>
//                         </div>
//                         <div class="contact-item">
//                             <span>Phone:</span>
//                             <a href="tel:+911122112233">+91 7065038327</a>
//                         </div>
//                         <div class="contact-item">
//                             <span>Address:</span>
//                             <p>Address: Branch, 371,<br />Ground Floor, 35, Khasra No. 369,370, 382, 100 Feet Rd, near Union Bank, Ghitorni, New Delhi, Delhi 110030</p>
//                         </div>
//                     </div>

//                     <form class="contact-form">
//                         <div class="form-row">
//                             <div class="form-group">
//                                 <label for="name">Your Name</label>
//                                 <input type="text" id="name" placeholder="Your name" />
//                             </div>
//                             <div class="form-group">
//                                 <label for="email">Email Address</label>
//                                 <input type="email" id="email" placeholder="Your email address" />
//                             </div>
//                         </div>

//                         <div class="form-group">
//                             <label for="message">Message</label>
//                             <textarea id="message" placeholder="Write something..."></textarea>
//                         </div>

//                         <button type="submit" class="submit-button">
//                             <span>Send Message</span>
//                             <div class="icon-wrapper">
//                                 <img src="assets/arrow2.png" className="h-7 w-7" alt="arrow" />
//                             </div>
//                         </button>
//                     </form>
//                 </div>
//             </section>


//             <section id="download" class="py-12 md:py-16 lg:py-14">
//                 <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <div class="rounded-[24px] md:rounded-[32px] bg-[#3F3B88] text-white overflow-hidden">

//                         <div
//                             class="flex flex-col p-6 md:p-10 lg:p-0 lg:grid lg:grid-cols-[minmax(220px,360px),1fr,180px] lg:items-center lg:gap-6">


//                             <div class="order-3 lg:order-1 w-full lg:w-auto flex lg:justify-start mt-6 lg:mt-0"
//                                 style={{ marginLeft: "-3rem", marginBottom: "-3rem" }}>
//                                 <img src="assets/handmockup.png" alt="Youvati app preview"
//                                     class="w-auto max-h-64 md:max-h-72 lg:max-h-80 object-contain pt-4" />
//                             </div>


//                             <div class="order-1 lg:order-2 w-full space-y-3 md:space-y-4 text-left lg:px-8">
//                                 <h3 class="text-2xl md:text-3xl font-syne leading-tight">
//                                     To Achieve Your Goals, There’s Only One Thing You Need.
//                                 </h3>
//                                 <p class="text-lg md:text-xl font-syne">
//                                     Download <span class="text-[#BFC3FF]">Youvati</span>
//                                 </p>
//                                 <p class="text-white/80 max-w-md">
//                                     Scan the QR code to download the app on your phone
//                                 </p>
//                             </div>


//                             <div
//                                 class="order-2 lg:order-3 flex flex-row lg:flex-col items-center justify-start lg:justify-center gap-4 mt-4 lg:mt-0 pr-0 lg:pr-10">


//                                 <div class="h-20 w-20 md:h-24 md:w-24 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('assets/y_icon.png')", backgroundRepeat: "no-repeat", backgroundPosition: "center", position: "relative", backgroundSize: "cover", height: "10rem" }}></div>


//                                 <div class=" h-20 w-20 md:h-24 md:w-24 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('assets/qrcode.png')", backgroundRepeat: "no-repeat", backgroundPosition: "center", position: "relative", backgroundSize: "cover", height: "10rem" }}></div>


//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </section>



//             <Footer />

//             <style>{`
//         :root {
//             --color-primary: #938EFA;
//             --color-primary-dark: #6c64f8;
//             --color-bg: #F6F5FA;
//             --color-white: #fff;
//             --color-dark-bg: #3b338f;
//             --text-dark: #111;
//             --text-gray: #555;
//         }

//         body {
//             font-family: 'Montserrat', sans-serif;
//             margin: 0;
//             padding: 0;
//             background-color: var(--color-bg);
//             color: var(--text-dark);
//         }

//         /* ---------------- CONTACT SECTION ---------------- */
//         .contact-section {
//             max-width: 1200px;
//             margin: 0 auto;
//             padding: 80px 24px;
//         }

//         .contact-card {
//             background: var(--color-white);
//             border-radius: 32px;
//             padding: 56px;
//             display: flex;
//             justify-content: space-between;
//             align-items: flex-start;
//             gap: 80px;
//             box-shadow: 0 8px 40px rgba(0, 0, 0, 0.04);
//         }

//         .contact-info {
//             flex: 1;
//         }

//         .contact-title {
//             font-family: 'Syne', sans-serif;
//             font-weight: 700;
//             font-size: 44px;
//             margin: 0 0 16px;
//         }

//         .contact-title .highlight {
//             color: var(--color-primary);
//         }

//         .contact-description {
//             font-size: 17px;
//             color: var(--text-gray);
//             margin-bottom: 32px;
//             max-width: 400px;
//         }

//         .contact-item {
//             margin-bottom: 20px;
//         }

//         .contact-item span {
//             display: block;
//             color: var(--text-gray);
//             font-weight: 500;
//             margin-bottom: 6px;
//         }

//         .contact-item a,
//         .contact-item p {
//             color: var(--text-dark);
//             font-weight: 600;
//             font-size: 18px;
//             text-decoration: none;
//         }

//         /* -------- FORM -------- */
//         .contact-form {
//             flex: 1.2;
//             display: flex;
//             flex-direction: column;
//             gap: 24px;
//         }

//         .form-row {
//             display: flex;
//             gap: 24px;
//         }

//         .form-group {
//             flex: 1;
//             display: flex;
//             flex-direction: column;
//             gap: 8px;
//         }

//         label {
//             font-weight: 600;
//         }

//         input,
//         textarea {
//             background: #f1efff;
//             border: none;
//             border-radius: 12px;
//             padding: 14px 16px;
//             font-size: 16px;
//             font-family: 'Montserrat', sans-serif;
//             resize: none;
//             color: var(--text-dark);
//         }

//         input::placeholder,
//         textarea::placeholder {
//             color: #aaa;
//         }

//         textarea {
//             height: 160px;
//         }

//         .submit-button {
//             background: var(--color-primary);
//             color: var(--color-white);
//             border: none;
//             border-radius: 28px;
//             padding: 12px 20px;
//             font-size: 17px;
//             font-weight: 500;
//             cursor: pointer;
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             transition: 0.3s;
//         }

//         .submit-button:hover {
//             background: var(--color-primary-dark);
//         }

//         .submit-button .icon-wrapper {
//             background: var(--color-white);
//             border-radius: 50%;
//             width: 34px;
//             height: 34px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//         }

//         .submit-button img {
//             width: 22px;
//             height: 22px;
//         }

//         /* ---------------- DOWNLOAD SECTION ---------------- */
//         .download-section {
//             padding: 80px 24px;
//         }

//         .download-container {
//             background: var(--color-primary-dark);
//             border-radius: 30px;
//             display: flex;
//             align-items: center;
//             justify-content: space-between;
//             padding: 48px 64px;
//             gap: 60px;
//             flex-wrap: wrap;
//             color: var(--color-white);
//         }

//         .download-left {
//             display: flex;
//             align-items: center;
//             gap: 40px;
//             flex: 1;
//             min-width: 320px;
//         }

//         .download-left img {
//             width: 180px;
//             height: auto;
//             border-radius: 24px;
//         }

//         .download-text h2 {
//             font-family: 'Syne', sans-serif;
//             font-size: 28px;
//             font-weight: 700;
//             margin: 0 0 16px;
//             line-height: 1.3;
//         }

//         .download-text p {
//             margin: 0;
//             font-size: 17px;
//             color: #ddd;
//         }

//         .download-qr {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 16px;
//         }

//         .qr-icon {
//             background: var(--color-primary);
//             width: 90px;
//             height: 90px;
//             border-radius: 12px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//         }

//         .qr-icon img {
//             width: 42px;
//         }

//         .qr-code {
//             background: var(--color-white);
//             border-radius: 10px;
//             padding: 8px;
//         }

//         .qr-code img {
//             width: 80px;
//             height: 80px;
//         }

//         /* ---------------- RESPONSIVE ---------------- */
//         /* ---------------- RESPONSIVE ---------------- */
//         @media (max-width: 1024px) {
//             .contact-card {
//                 flex-direction: column;
//                 gap: 48px;
//                 padding: 40px 32px;
//             }

//             .contact-title {
//                 font-size: 36px;
//             }

//             .form-row {
//                 flex-direction: column;
//                 gap: 20px;
//             }

//             /* ✅ make all form fields full width on mobile/tablet */
//             .form-group {
//                 width: 100%;
//             }

//             .contact-form {
//                 width: 100%;
//             }

//             input,
//             textarea {
//                 width: 100%;
//                 box-sizing: border-box;
//             }

//             .download-container {
//                 flex-direction: column;
//                 text-align: center;
//                 padding: 48px 32px;
//             }

//             .download-left {
//                 flex-direction: column;
//                 align-items: center;
//                 gap: 24px;
//             }
//         }

//         @media (max-width: 600px) {
//             .contact-section {
//                 padding: 60px 16px;
//             }

//             .contact-card {
//                 padding: 32px 20px;
//             }

//             input,
//             textarea {
//                 font-size: 15px;
//             }

//             .submit-button {
//                 font-size: 15px;
//             }

//             /* ✅ Ensure submit button spans full width on small phones */
//             .submit-button {
//                 width: 100%;
//                 justify-content: center;
//                 gap: 8px;
//             }

//             .download-left img {
//                 width: 140px;
//             }

//             .download-text h2 {
//                 font-size: 22px;
//             }

//             .qr-icon {
//                 width: 70px;
//                 height: 70px;
//             }

//             .qr-code img {
//                 width: 70px;
//                 height: 70px;
//             }
//         }


//         `}</style>


//         </>

//     );
// }

// export default Contactus;
